__turbopack_context__.v({
  "blue": "CosmeticLights-module-scss-module__EDeoIq__blue",
  "brightness-100": "CosmeticLights-module-scss-module__EDeoIq__brightness-100",
  "brightness-25": "CosmeticLights-module-scss-module__EDeoIq__brightness-25",
  "brightness-50": "CosmeticLights-module-scss-module__EDeoIq__brightness-50",
  "brightness-75": "CosmeticLights-module-scss-module__EDeoIq__brightness-75",
  "flicker-100": "CosmeticLights-module-scss-module__EDeoIq__flicker-100",
  "flicker-25": "CosmeticLights-module-scss-module__EDeoIq__flicker-25",
  "flicker-50": "CosmeticLights-module-scss-module__EDeoIq__flicker-50",
  "flicker-75": "CosmeticLights-module-scss-module__EDeoIq__flicker-75",
  "green": "CosmeticLights-module-scss-module__EDeoIq__green",
  "light": "CosmeticLights-module-scss-module__EDeoIq__light",
  "red": "CosmeticLights-module-scss-module__EDeoIq__red",
  "yellow": "CosmeticLights-module-scss-module__EDeoIq__yellow",
});
